// extracted by mini-css-extract-plugin
module.exports = {"SectionA6":"SectionPhone_SectionA6__pd4Zj"};